import * as Preact from "preact"
import App from "@fae/source/models/App.js"

import "./DevToys.less"

import Dev from "@fae/source/models/dev/Dev.js"
import Geometry from "@fae/source/utility/Geometry.js"

export default class DevToys {
    render() {
        if(App.game.chapter == undefined) return
        if(Dev.devSelection == undefined) return
        return (
            <div class="DevToys">
                {this.cursor}
                {this.notifications}
            </div>
        )
    }
    get cursor() {
        const stage = this.props.stage || App.game.chapter.stage
        if(stage == undefined) return
        return (
            <div class="HoveredCursor DevToy">
                <div class="Toast" isActive={true}>
                    {App.game.chapter.selection.position.x == Infinity ? "∞" : App.game.chapter.selection.position.x}
                    x
                    {App.game.chapter.selection.position.y == Infinity ? "∞" : App.game.chapter.selection.position.y}
                </div>
                {Object.values(stage.world.encounters).filter((encounter) => {
                    return Geometry.isInBounds(encounter, App.game.chapter.selection.position)
                }).map((encounter) => {
                    return (
                        <div class="Small Toast" isActive={encounter.key == Dev.devSelection.selectedEncounterKey}>
                            encounter#{encounter.key}
                        </div>
                    )
                })}
                {Dev.mode != "geography" && Object.values(stage.units).filter((unit) => {
                    return unit.position.x == App.game.chapter.selection.position.x
                        && unit.position.y == App.game.chapter.selection.position.y
                }).map((unit) => {
                    return (
                        <div class="Small Toast" isActive={unit.key == App.game.chapter.selection.selectedUnitKey}>
                            unit#{unit.key}
                        </div>
                    )
                })}
                {Dev.mode != "geography" && Object.values(stage.world.spots).filter((spot) => {
                    return spot.position.x == App.game.chapter.selection.position.x
                        && spot.position.y == App.game.chapter.selection.position.y
                }).map((spot) => {
                    return (
                        <div class="Small Toast" isActive={spot.key == Dev.devSelection.selectedSpotKey}>
                            spot#{spot.key}
                        </div>
                    )
                })}
            </div>
        )
    }
    get notifications() {
        const NOTIFICATION_DURATION = 2000
        const isVisible = Dev.notification?.message != undefined
            && Date.now() - Dev.notification?.startTime < NOTIFICATION_DURATION
        return (
            <div class="Notification DevToy">
                <div class="Toast" key={Dev.notification?.startTime} type={Dev.notification?.type} isVisible={isVisible}>
                    <span class="material-symbols-rounded">{Dev.notification?.type == "failure" ? "error" : "check_circle"}</span>
                    <span>{Dev.notification?.message}</span>
                </div>
            </div>
        )
    }
}
